import React from 'react';
import {images} from '../../constants'
import {SubHeading} from '../../components'
import {BsInstagram,BsArrowLeftShort,BsArrowRightShort} from 'react-icons/bs'
import './Gallery.css';

const Gallery = () => {
  const scrollRef = React.useRef();
  const scroll = (direction) =>{const {current} = scrollRef;if (direction==='left'){current.scrollLeft -=250}else{current.scrollLeft+=250}}

  return(
    <div className='gallery flex__center'>
      <div className='gallery-content'>
        <SubHeading title='Instagram'/>
        <h1 className='headtext__cormorant'>Photo Gallery</h1>
        <p className='p__opensans' style={{color:'#AAAAAA',marginTop:'2rem'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat mattis ipsum turpis elit elit scelerisque egestas mu.</p>
        <button type='button' className='custom__button'>View More</button>
      </div>
      <div className='gallery-images'>
        <div className='images-container' ref={scrollRef}>
          {[images.gallery01,images.gallery02,images.gallery03,images.gallery04].map((image,index)=>(
            <div className='image-card flex__center' key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
              <BsInstagram className='image-icon'/>
            </div>
          ))}
        </div>
        <div className='images-arrow'>
          <BsArrowLeftShort className='arrow-icon' onClick={()=>scroll('left')}/>
          <BsArrowRightShort className='arrow-icon' onClick={()=>scroll('right')}/>
        </div>
      </div>
    </div>
  )
}

export default Gallery;
